  import { NgModule } from '@angular/core';
  import { BrowserModule } from '@angular/platform-browser';
  import { RouteReuseStrategy } from '@angular/router';
  import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
  import { AppComponent } from './app.component';
  import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
  import { TranslateHttpLoader } from '@ngx-translate/http-loader';
  import { LanguageService } from './provider/language.service';
  import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
  import {appRoutes} from "./app.routes";
  import {SharedModule} from "./shared/shared.module";
  // import {SocketIoConfig, SocketIoModule} from "ngx-socket-io";
  import {environment} from "../environments/environment";
  import {ComponentsModule} from "./shared/components/components.module";
  import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
  import {PrivatePageModule} from "./private/private.module";
  import {AuthenticationModule} from "./authentication/authentication.module";
  import {AuthInterceptor} from "./shared/_services/abstract/AuthInterceptor";
  import {PublicPageModule} from "./public/public.module";
  import {NgxStripeModule} from "@nomadreservations/ngx-stripe";
  import {SharedNavigationService} from "./shared/_services/sharednavigation.service";
  import {HashLocationStrategy, LocationStrategy, PathLocationStrategy} from "@angular/common";



  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
  }
  // const socketIoConfig: SocketIoConfig = { url: environment.socket, options: {} };

  @NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
      IonicModule.forRoot(),
      appRoutes,
      HttpClientModule,
      IonicModule.forRoot(),
      FontAwesomeModule,
      PrivatePageModule,
      PublicPageModule,
      AuthenticationModule,
      SharedModule,
      ComponentsModule,
      // SocketIoModule.forRoot(socketIoConfig),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      }),
      NgxStripeModule.forRoot(environment.stripeKey),

    ],
    providers: [
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
      { provide: LocationStrategy, useClass: PathLocationStrategy },

      LanguageService,
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      SharedNavigationService
    ],


    bootstrap: [AppComponent],
  })
  export class AppModule { }
